import { _CustomItemQuestionItem } from "@Components/form/CreateFormItem/interface";
import { VisitField, VisitFiles } from "@Interface/visit";
import { determineRegion } from "@Utils/utils";
import { Col, Form, FormInstance, Input, Radio, Row } from "antd";
import React, { useEffect } from "react";
import RenderFormItem from "../../../_RenderFormItem";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  form: FormInstance<any>;
  values: _CustomItemQuestionItem;
  disabled?: boolean;
  visitInfo?: VisitField | null;
  fileList?: VisitFiles[];
}

const FormItemDoctor = ({ values, disabled, fileList, ...props }: Props) => {
  const markers = Form.useWatch("markers", props.form);
  const valueForm = Form.useWatch(values["keyName"], props.form);
  useEffect(() => {
    if (values["keyName"] === "diagnosisFormGroup2_question1") {
      const abusValue = markers
        ?.map((item: any, index: number) => {
          return {
            plotNumber: index + 1,
            ...item,
          };
        })
        ?.filter((item: any) => {
          return item?.type === "abus";
        });
      handleFormFollowPlotLocation(values["keyName"], abusValue, valueForm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.form, markers, valueForm]);

  const handleFormFollowPlotLocation = (
    keyName: string,
    watchForm: any,
    valueForm: any
  ) => {
    if (watchForm?.length > 0) {
      const newFields = watchForm?.map((e: any) => {
        const location = determineRegion(e.top, e.left);
        const key = `${e.top}_${e.left}`;
        const resultDiagnosisForm =
          props.visitInfo?.diagnosisForm?.formData?.[keyName] || [];
        const newValueForm = [...(valueForm || []), ...resultDiagnosisForm];
        const findOldContent = newValueForm?.find(
          (el: any) => el?.name === key
        );
        if (findOldContent) {
          return { plotNumber: e.plotNumber, ...findOldContent };
        } else {
          return {
            plotNumber: e.plotNumber,
            name: key,
            location: location,
          };
        }
      });
      // Set preset values for the fields
      props.form.setFieldsValue({
        [keyName]: [...newFields],
      });
    } else {
      props.form.setFieldsValue({
        [keyName]: [],
      });
    }
  };

  return (
    <>
      <Form.List name={values["keyName"]}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map(({ key, name, ...restField }) => {
              const choice = props.form.getFieldValue([
                values["keyName"],
                name?.toString(),
                values?.choice?.[0]?.keyName,
              ]);
              return (
                <div
                  className="box"
                  key={key}
                  style={{ padding: 20, minHeight: "100px" }}
                >
                  <Row align="middle" justify="space-between">
                    <Col>
                      <Form.Item name={[name, "plotNumber"]} key={"plotNumber"}>
                        <span>{values.title}</span>
                        <span>
                          {`( Plot No : ${props.form.getFieldValue([
                            values["keyName"],
                            name?.toString(),
                            "plotNumber",
                          ])} )`}
                        </span>
                      </Form.Item>
                    </Col>
                    <Col>
                      {!!values.choice && (
                        <>
                          <RenderFormItem
                            form={props.form}
                            values={values.choice}
                            disabled={disabled}
                            isFormList={String(name)}
                          />
                        </>
                      )}
                    </Col>
                  </Row>
                  {choice?.toLowerCase() === "yes" ? (
                    <>
                      <Row
                        key={key}
                        align="middle"
                        justify="space-between"
                        gutter={[16, 16]}
                      >
                        <Col span={24}>
                          {!!values.children && (
                            <RenderFormItem
                              form={props.form}
                              values={values.children}
                              isFormList={String(name)}
                              disabled={disabled}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row>
                        {!!values.media && (
                          <>
                            <RenderFormItem
                              form={props.form}
                              values={values.media}
                              disabled={disabled}
                              cusname={String(name)}
                              visitInfo={props.visitInfo}
                              fileList={fileList}
                            />
                          </>
                        )}
                      </Row>

                      {!!values.children &&
                        values.children.map((item, ind: number) => {
                          if (item.index === "end") {
                            return (
                              <Row key={ind} gutter={[16, 16]} align="middle">
                                <Col>{item.title}</Col>
                                <Col>
                                  <Form.Item
                                    name={[name, item["keyName"]]}
                                    key={item["keyName"]}
                                  >
                                    <Input
                                      style={{ marginTop: "25px" }}
                                      disabled={disabled}
                                      className="form-masscyst"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            );
                          } else return null;
                        })}
                    </>
                  ) : null}
                </div>
              );
            })}
            {fields.length === 0 && (
              <Form.Item label={values.title}>
                <Radio checked disabled className="content-radio">
                  None
                </Radio>
              </Form.Item>
            )}
          </>
        )}
      </Form.List>
    </>
  );
};

export default FormItemDoctor;
